import Input from "../../material/input/Input";

const PositionRegistration = ({
  position,
  setPosition,
}) => {
  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <div className="grid grid-cols-2 md:grid-cols-1 gap-4">
        <Input
          label="ตำแหน่ง"
          placeholder="ตำแหน่ง"
          value={position}
          setValue={setPosition}
        />

        <div className="block md:hidden" />
      </div>
    </div>
  );
};

export default PositionRegistration;
